import styled from "styled-components";
export const DashboardWrraper = styled.div`
    .dash-header {
        display: flex;
        justify-content: space-between;
        align-items: start;
        flex-flow: wrap;
        gap: 15px;

        .heading {
            width: 100%;
            font-size: 18px;
            line-height: 22px;
            font-weight: 300;
            color: var(--gray);

            @media (min-width: 1200px) {
                width: auto;
            }

            h2 {
                font-weight: 400;

                @media (min-width: 768px) {
                    font-size: 28px;
                    line-height: 32px;
                }
            }
        }
    }
    .dropdownWrap {
        width: 100%;
        border: 1px solid var(--gray-100);
        border-radius: 14px;

        @media (min-width: 992px) {
            max-width: 270px;
        }
        @media (min-width: 1400px) {
            max-width: 350px;
        }
        .react-select__control {
            background: var(--white);
            border: none;
            font-size: 18px;
            line-height: 22px;
        }
    }

    .period-filter {
        margin: 0 0 10px;
        display: flex;
        flex-direction: column;
        gap: 15px;

        @media (min-width: 992px) {
            margin: 0 0 20px;
        }

        .period-tabs {
            display: flex;
            gap: 10px;
            flex-wrap: wrap;

            button {
                padding: 10px 20px;
                border: 1px solid #e5e5e5;
                border-radius: 25px;
                background: var(--white);
                color: var(--gray);
                font-size: 14px;
                font-weight: 400;
                cursor: pointer;
                transition: all 0.3s ease;
                white-space: nowrap;

                @media (min-width: 992px) {
                    font-size: 15px;
                    padding: 8px 15px;
                }
                @media (min-width: 1400px) {
                    font-size: 16px;
                    padding: 12px 24px;
                }

                &:hover {
                    border-color: ${({theme}) => theme?.light?.primary};
                    color: ${({theme}) => theme?.light?.primary};
                }

                &.active {
                    background: ${({theme}) => theme?.light?.primary};
                    color: var(--white);
                    border-color: ${({theme}) => theme?.light?.primary};
                }
            }
        }

        .custom-date-picker {
            display: flex;
            align-items: center;
            gap: 10px;
            flex-wrap: wrap;

            input[type="date"] {
                padding: 10px 15px;
                border: 1px solid #e5e5e5;
                border-radius: 10px;
                font-size: 14px;
                color: var(--gray);
                background: var(--white);
                cursor: pointer;
                transition: border-color 0.3s ease;

                @media (min-width: 768px) {
                    font-size: 16px;
                    padding: 12px 18px;
                }

                &:focus {
                    outline: none;
                    border-color: ${({theme}) => theme?.light?.primary};
                }

                &::-webkit-calendar-picker-indicator {
                    cursor: pointer;
                    filter: opacity(0.6);
                }
            }

            span {
                color: var(--gray);
                font-size: 14px;
                font-weight: 300;

                @media (min-width: 768px) {
                    font-size: 16px;
                }
            }
        }
    }

    .business-details {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        @media (min-width: 768px) {
            grid-template-columns: repeat(2, 1fr);
        }
        @media (min-width: 991px) {
            grid-template-columns: repeat(3, 1fr);
        }
        gap: 20px;
        padding: 20px 0;
        .card {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 10px;
            padding: 15px;
            box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.11);
            border-radius: 15px;
            .title {
                font-size: 16px;
                line-height: 20px;
                font-weight: 300;
                color: var(--gray);
                @media (min-width: 768px) {
                    font-size: 18px;
                    line-height: 22px;
                }
                h2 {
                    font-weight: 400;
                    @media (min-width: 768px) {
                        font-size: 28px;
                        line-height: 32px;
                    }
                }
            }
            .image-wrap {
                max-width: 60px;
                padding: 8px;
                border-radius: 50%;
                background-color: ${({theme}) => theme?.light?.primary};
                img {
                    width: 25px;
                    height: 25px;
                    @media (min-width: 768px) {
                        width: 30px;
                        height: 30px;
                    }
                }
            }
        }
    }
    .graphs {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        @media (min-width: 991px) {
            grid-template-columns: repeat(2, 1fr);
        }
        gap: 20px;
        margin-bottom: 30px;
    }
`;
export const ChartWrapper = styled.div`
    padding: 20px;
    background-color: #fff;
    border-radius: 15px;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.11);
    .heading {
        @media (min-width: 575px) {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            gap: 20px;
        }
    }
    .title {
        color: var(--gray);
        margin-bottom: 30px;
        font-size: 16px;
        line-height: 20px;
        font-weight: 300;
        @media (min-width: 768px) {
            font-size: 18px;
            line-height: 22px;
        }
    }
    .revenue-dropdown {
        position: relative;
        width: 100%;
        max-width: 130px;
        .dropdown {
            display: flex;
            justify-content: space-between;
            gap: 10px;
            align-items: center;
            position: relative;
            border-radius: 15px;
            border: 1px solid var(--gray-tune, #dfdfdf);
            text-align: center;
            font-size: 18px;
            line-height: 22px;
            font-weight: 300;
            padding: 10px;
            color: #313131;
            cursor: pointer;
            p {
                margin: 0;
            }
        }
        .styled-select {
            position: absolute;
            top: 50px;
            left: 0;
            width: 130px;
            background: var(--white);
            border: 1px solid var(--gray-tune, #dfdfdf);
            border-radius: 8px;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
            text-align: left;
            font-size: 16px;
            line-height: 22px;
            font-weight: 300;
            padding: 10px 0;
            z-index: 1;

            li {
                padding: 5px 15px;
                cursor: pointer;
                color: #313131;
                &:hover {
                    background: var(--primary);
                    color: var(--white);
                }
            }
        }
    }
    /* .lineChart {
   svg{
    opacity: 0.8;
   }
  } */
`;
export const OrderSummaryWrap = styled.div`
    background-color: #ffffff;
    border-radius: 15px;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.11);
    padding: 10px;
    @media (min-width: 575px) {
        padding: 20px;
    }
    .header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 20px;
        font-size: 16px;
        line-height: 20px;
        font-weight: 300;
        color: var(--gray);
        flex-direction: column-reverse;
        @media (min-width: 768px) {
            flex-direction: row;
            font-size: 18px;
            line-height: 22px;
        }
    }
    .summary-tabs {
        display: flex;
        gap: 15px;
        font-size: 14px;
        line-height: 18px;
        font-weight: 300;
        color: var(--gray);
        span {
            cursor: pointer;
            border-bottom: none;
            padding-bottom: 5px;
        }
        span.active {
            color: ${({theme}) => theme?.light?.primary};
            border-bottom: 2px solid ${({theme}) => theme?.light?.primary};
        }
    }
    .new-orders {
        background-color: #e7f9ef;
        padding: 10px;
        border-radius: 5px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 15px;
        margin-bottom: 20px;
        gap: 10px;
        @media (min-width: 575px) {
            gap: 15px;
        }
        span {
            font-size: 16px;
            line-height: 20px;
            font-weight: 300;
            color: var(--black);
            white-space: nowrap;
            strong {
                background-color: #27c453;
                color: #fff;
                padding: 7px;
                border-radius: 10px;
                margin-right: 5px;
                @media (min-width: 575px) {
                    margin-right: 10px;
                }
            }
        }
        .manage-order-list {
            display: flex;
            justify-content: center;
            align-items: center;
            color: ${({theme}) => theme?.light?.primary};
            font-weight: bold;
            cursor: pointer;
            white-space: nowrap;
            @media (min-width: 575px) {
                gap: 10px;
            }
            p {
                margin: 0;
            }
            svg {
                width: 30px;
                height: 30px;
                color: var(--gray);
            }
        }
    }
    .order-stats {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        @media (min-width: 575px) {
            grid-template-columns: repeat(2, 1fr);
        }
        @media (min-width: 991px) {
            grid-template-columns: repeat(4, 1fr);
        }
        gap: 20px;
        .stat-card {
            border-radius: 15px;
            padding: 15px;
            text-align: center;
            width: 100%;
            color: var(--gray);
            border: 1px solid var(--gray-line, #ececec);
            font-size: 16px;
            line-height: 20px;
            font-weight: 300;
            @media (min-width: 768px) {
                font-size: 18px;
                line-height: 22px;
            }
        }
    }
`;
export const OrderChart = styled.div`
    @media (min-width: 575px) {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 20px;
    }
    margin-top: 20px;
    .chart > div {
        width: 100% !important;
        height: 150px !important;
        /* svg{
        width: 180px;
    } */
    }
    /* .progress-bars{
    width: 100%;
  } */
`;
export const ProgressBar = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 10px;
    .label {
        width: 100px;
        font-size: 12px;
        color: #888;
    }

    .bar-container {
        position: relative;
        width: 80px;
        height: 8px;
        background-color: #e0e0e0;
        border-radius: 5px;
        overflow: hidden;
        @media (min-width: 575px) {
            width: 100px;
        }
        @media (min-width: 1200px) {
            width: 200px;
        }
    }

    .bar {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        background-color: ${props => props.color || "#000"};
        border-radius: 5px;
    }

    span {
        font-size: 12px;
        color: #333;
    }
`;
export const DashbaordModal = styled.div`
    button {
        display: flex;
        justify-content: center;
        margin: 0 auto;
    }
`;
